
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  selectedTroughListItemWidth: {
    id: "SelectedTroughListItemWidth.width",
    defaultMessage: "Width",
  }, 
  selectedTroughListItemMinWidth: {
    id: "SelectedTroughListItemWidth.minWidth",
    defaultMessage: "Min Width",
  }, 
  selectedTroughListItemDepth: {
    id: "SelectedTroughListItemDepth.depth",
    defaultMessage: "Depth",
  }, 
  selectedTroughListItemMinDepth: {
    id: "SelectedTroughListItemDepth.minDepth",
    defaultMessage: "Min Depth",
  }, 
  selectedTroughListItemHeight: {
    id: "SelectedTroughListItemHeight.height",
    defaultMessage: "Height",
  },
  selectedTroughListItemMinDimensions: {
    id: "SelectedTroughListItemHeight.minDimensions",
    defaultMessage: "min. washbasin width x depth",
  }
});

export default MESSAGES;